// Angular
import { Component, Input, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';
import { NextJsSyncGuard } from '../../../../../core/guards/next-js-sync.guard';
import { Router } from '@angular/router';


@Component({
  selector: 'kt-user-profile4',
  templateUrl: './user-profile4.component.html',
})
export class UserProfile4Component implements OnInit {
  // Public properties
  user$: Observable<User>;
  user: User;

  @Input() avatar = true;
  @Input() greeting = true;
  @Input() badge: boolean;
  @Input() icon: boolean;

  /**
   * Component constructor
   *
   * @param store: Store<AppState>
   */
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private nextJsSyncGuard: NextJsSyncGuard) {
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    this.user$ = this.store.pipe(select(currentUser));
    const userString = localStorage.getItem('currentUser');
    this.user = (JSON.parse(userString) as User);
  }

  /**
   * Log out
   */
  logout() {
    this.store.dispatch(new Logout());
  }

  // Add this method to your Angular component (header, navigation, or profile)
syncWithNextJs(targetRoute: string) {
    // First save sync data
    this.nextJsSyncGuard.saveSyncData().subscribe(
      response => {
        if (response && response.statusCode === 200) {
          // Then open Next.js window with the target route
          this.nextJsSyncGuard.syncWithNextJs(targetRoute);
        } else {
          console.error('Sync data not saved');
        }
      },
      error => {
        console.error('Failed to sync data:', error);
      }
    );
  }

  // Add this method to your component class
hasMenuPermission(menuId: number): boolean {
  const menuPermissionStr = localStorage.getItem('menuPermission');
  
  if (!menuPermissionStr) {
    return false;
  }
  
  try {
    const menuPermissions = JSON.parse(menuPermissionStr);
    
    // Check if menuPermissions is an array
    if (Array.isArray(menuPermissions)) {
      // If it's an array of menu IDs
      return menuPermissions.includes(menuId);
    } 
    // If it's an array of objects with menuId property
    else if (Array.isArray(menuPermissions.menuList)) {
      return menuPermissions.menuList.some(menu => menu.menuId === menuId);
    }
    // If it has a different structure with direct properties
    else {
      return menuPermissions[menuId] !== undefined || 
             (menuPermissions.menuIds && menuPermissions.menuIds.includes(menuId));
    }
  } catch (error) {
    console.error('Error parsing menu permissions from localStorage:', error);
    return false;
  }
}
}
